<template>
  <div>
    <b-card no-body class="p-2 container-card">
      <b-row>
        <b-col cols="12" class="px-2">
          <div>
            <div class="d-flex justify-content-end mb-1">
              <add-button
                v-if="getPermissionModule('Privileges').adjust"
                :btn-label="'Privilege'"
                @click.native="onClickAddData"
              />
              <export-button v-if="getPermissionModule('Privileges').adjust" class="ml-2" @onExport="onOpenExportModal" />
            </div>
            <div class="d-flex flex-wrap justify-content-end">
              <div class="mr-1 ml-1 mb-1">
                <v-select
                  id="privilege-type-status"
                  v-model="formStatus.status"
                  class="v-select-filter bg-dropdown"
                  :class="formStatus.status ? 'v-select-filter-selected' : null"
                  placeholder="Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('status', option)"
                />
              </div>
              <div class="search-container mb-1">
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :key="tableModeReorder + keyChange"
                v-sortable-row="sortableRowOptions"
                :fields="fields"
                :items="privilegeTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table"
                :class="tableModeReorder ? 'table-reorder' : null"
              > -->
              <b-table
                :key="tableModeReorder + keyChange"
                v-sortable-row="sortableRowOptions"
                :fields="fields"
                :items="privilegeTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table-vertical"
                :class="tableModeReorder ? 'table-reorder' : null"
              >
                <template #head(image_url)="data">
                  <div class="text-center">
                    {{ data.field.label }}
                  </div>
                </template>
                <template #cell(image_url)="data">
                  <div class="d-flex justify-content-center">
                    <img
                      :src="data.item.image_url || DefaultImg"
                      class="image-column"
                    />
                  </div>
                </template>
                <template #cell(category)="data">
                  <div>
                    {{
                      buildCategoryFromPayload(
                        data.item.privilege_category_mapping
                      )
                    }}
                  </div>
                </template>
                <template #cell(status)="data">
                  <div class="d-flex align-items-center">
                    <feather-icon
                      icon="CircleIcon"
                      class="mr-2"
                      :class="resolveStatusClass(data.item.status)"
                    />

                    <span>{{ resolveStatusLabel(data.item.status) }}</span>
                  </div>
                </template>
                <template #cell(actions)="data">
                  <action-group
                    v-if="getPermissionModule('Privileges').adjust"
                    :resolve-action="resolveMappingTableAction"
                    :set-action-list="privilegeActionList"
                    :item-data="data"
                  />
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            reordering
            :pagination="pagination"
            @reorder="onClickReorder"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
    <reorder-modal
      v-if="modalType.reorder"
      :current-index="currentIndex"
      :reorder-action="reorderPrivilege"
      @onCloseModal="onCloseModalPrivilege"
    />
    <assign-inventory-modal
      v-if="modalType.assignInventory"
      :privilege-obj="privilegeSelect"
      @onCloseModal="onCloseModalPrivilege"
      @onSelectAssignInventory="onSelectAssignInventory"
    />
    <mapping-category-modal
      v-if="modalType.mappingCategory"
      :privilege-obj="privilegeSelect"
      @onCloseModal="onCloseModalPrivilege"
    />
    <history-report-modal
      v-if="modalPopup.report"
      @onCloseModal="closeReportModal"
      :moduleTypeKey="defaultReportFilterType.module"
      :moduleKey="defaultReport.privilege"
    />
  </div>
</template>

<script>
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import ReorderModal from "@/@core/components/reorder-modal/ReorderModal.vue";
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";
import AssignInventoryModal from "./components/AssignInventoryModal.vue";
import MappingCategoryModal from "./components/MappingCategoryModal.vue";
import usePrivilegeList from "./hooks/usePrivilegeList";
import ExportButton from "@/views/components/button/ExportButton.vue";
import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";
import {
  defaultReport,
  defaultReportFilterType,
  defaultReportCategory,
} from "@/configs/dynamic-config/dynamic-report";

export default {
  components: {
    CardNoItem,
    ActionGroup,
    AddButton,
    Search,
    vSelect,
    PaginationWithReorder,
    ReorderModal,
    AssignInventoryModal,
    MappingCategoryModal,
    ExportButton,
    HistoryReportModal,
  },
  setup() {
    const {
      pagination,
      formStatus,
      fields,
      statusOption,
      loading,
      privilegeTable,
      privilegeActionList,
      sortableRowOptions,
      tableModeReorder,
      keyChange,
      currentIndex,
      modalType,
      privilegeSelect,
      reorderPrivilege,
      onClickReorder,
      resolveMappingTableAction,
      resolveStatusLabel,
      resolveStatusClass,
      onCloseModalPrivilege,
      buildCategoryFromPayload,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      onSelectAssignInventory,
      onClickAddData,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
      getPermissionModule
    } = usePrivilegeList();

    return {
      DefaultImg,
      pagination,
      formStatus,
      fields,
      statusOption,
      loading,
      privilegeTable,
      privilegeActionList,
      sortableRowOptions,
      tableModeReorder,
      keyChange,
      currentIndex,
      modalType,
      privilegeSelect,
      resolveMappingTableAction,
      resolveStatusLabel,
      resolveStatusClass,
      reorderPrivilege,
      onClickReorder,
      onCloseModalPrivilege,
      buildCategoryFromPayload,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      onSelectAssignInventory,
      onClickAddData,
      defaultReport,
      defaultReportFilterType,
      defaultReportCategory,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
      getPermissionModule
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/status.css";
@import "~@/assets/css/pages/privilege/privilege-list.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>
